import { createContext, useContext } from 'react';
var UpsellContext = createContext({});
export var UpsellContextProvider = UpsellContext.Provider;
export var useUpsellContext = function () {
    return useContext(UpsellContext);
};
